import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ActionButton, Icon } from '../../../../modules/modules';
import CountryService from '../../../../services/CountryService';
import GoogleTagManagerService from '../../../../services/GoogleTagManagerService';

interface ISearchProps extends RouteComponentProps<{ language: string }> {
  cart?: boolean;
  navData?: any;
}

interface ISearchState {
  query: string;
}

class Search extends React.Component<ISearchProps, ISearchState> {
  constructor(props: ISearchProps) {
    super(props);

    this.state = {
      query: '',
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  private handleKeyPress(e: any) {
    if (e.key !== 'Enter' || this.state.query === '') {
      return;
    }

    this.handleSearch();
  }

  private handleSearch() {
    if (this.state.query !== '') {
      const { countryCode, currencyCode } = CountryService.GetInstance();
      this.setState({
        query: '',
      });
      // Country code urls are not used anymore
      // this.props.history.push(`/${countryCode}/products?q=${escape(this.state.query)}`);
      const params = new URLSearchParams(this.props.location.search);
      params.set('q', this.state.query);
      if (!params.get('currency')) {
        params.set('currency', currencyCode);
      }
      this.props.history.push(`/products?${params.toString()}`);
    }
  }

  public render() {
    return (
      <div className="header__main__search">
        <input
          className="header__main__search__input"
          type="text"
          placeholder="What are you looking for? e.g. Divesoft Analyzer..."
          value={this.state.query}
          onChange={e => this.setState({ query: e.target.value })}
          onKeyPress={this.handleKeyPress}
          onFocus={GoogleTagManagerService.startSearch}
        />
        <Icon type="search" className="header__main__search__icon" />
        <ActionButton type="primary" onClick={this.handleSearch} className="header__main__search__button">
          Search
        </ActionButton>
      </div>
    );
  }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/components/Header/components/Search/Search.tsx